/// Bảng màu avatar chữ cái của bản thiết kế — một người luôn ra cùng một màu.
const TONES = ['var(--navy-500)', 'var(--navy-700)', 'var(--navy-300)', 'var(--navy-900)', '#2e6f9e'];

/** "Trần Quốc Bảo" -> "QB": 2 chữ cuối, vì tên Việt nằm cuối họ tên. */
function initials(name: string) {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(-2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

export function Avatar({
  name,
  size = 40,
  mark,
  online = false,
  tone,
}: {
  name: string;
  size?: number;
  /** Có giá trị = avatar nhóm: ô bo 12px với 1 chữ kanji thay vì hình tròn chữ cái. */
  mark?: string | null;
  online?: boolean;
  tone?: number;
}) {
  const group = !!mark;
  return (
    <span style={{ position: 'relative', width: size, height: size, flexShrink: 0, display: 'block' }}>
      <span
        style={{
          width: size,
          height: size,
          borderRadius: group ? 12 : '50%',
          background: TONES[tone ?? name.length % TONES.length],
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: group ? 'var(--font-jp)' : 'var(--font-vi)',
          fontWeight: 700,
          fontSize: Math.round(size * (group ? 0.42 : 0.36)),
        }}
      >
        {mark || initials(name) || '?'}
      </span>
      {online && (
        <span
          aria-label="Đang hoạt động"
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: Math.round(size * 0.28),
            height: Math.round(size * 0.28),
            borderRadius: '50%',
            background: 'var(--success)',
            border: '2px solid var(--surface-page)',
          }}
        />
      )}
    </span>
  );
}
